/**
 * File: qpSummary.js
 * Project: educore
 * Created Date: 2018-12-13
 * Author: Raziya S
 * Screen : 
 */
import templateProgressPopup from '../views/progress_popup.html'
import procturedDocumentPopup from '../views/procturedDocument.html'
import proceedViewPopup from '../views/proceedView.html'
class ActivitySubmissionController {
    // @ngInject
    constructor($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, SchoolLogo, CONSTANTS, $sce) {


        let authoring = localStorageService.get("authoringData")
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
        if (authoring === undefined)
            $state.go('dashboard')
        $scope.score = 0
        let qpId = $stateParams.qpId
        $scope.minutes = []
        for (var min = 5; min <= 20; min += 5) {
            $scope.minutes.push(min);
        }
        let self = this
        $scope.isLoading = true
        $scope.class = authoring.class
        let userId = localStorageService.get('user_id')
        let schoolId = authoring.school_id
        authService.callAPI(activityCons.API_GET_SCHOOL_DETAILS + schoolId, "POST", {}, (response) => {
            if (response.result && response.result.status && response.result.data.details) {
                let result = response.result.data.details
                $scope.qpHeader = {
                    'schoolName': result.school_name,
                    'schoolLogo': SchoolLogo.checkLogo(CONSTANTS.FILE_UPLOAD_URL + result.logo),
                    'subject': authoring.subject,
                    'class': authoring.class
                }
                $scope.$apply()
            } else {
                //error
            }
        })
        getQp()

        $scope.auto_evaluating = false
        function getQp() {
            try {


                authService.callAPI(activityCons.API_GET_QP_ATTENDEE_DETAILS + qpId, "GET", {}, function (response) {
                    if (response.result && response.result.data && response.result.data.details) {
                        try {
                            $scope.isLoading = false
                            $scope.questionPaper = response.result.data.details;
                            console.log($scope.questionPaper)
                            $scope.questionPaper.auto_evaluating = false
                            if ($scope.questionPaper && $scope.questionPaper.time) {
                                $scope.hour = $scope.questionPaper.time.hour;
                                $scope.min = $scope.questionPaper.time.min;
                            }
                            if ($scope.questionPaper && $scope.questionPaper.due_date) {
                                $scope.date = $scope.questionPaper.due_date;
                            }
                            if ($scope.questionPaper && $scope.questionPaper.students) {
                                $scope.assignedUsers = $scope.questionPaper.students;
                            }

                            if ($scope.assignedUsers.length>0) {
                                modifyLoginDetails();
                            }

                            if ($scope.assignedUsers.length > 0 && $scope.questionPaper.status != 'completed') {
                                generateAlertMessage();
                            }
                        } catch (ex) {
                            console.log(ex);
                        }
                    } else {
                        //toastr.error('Network Error. Please try later');
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                });
            } catch (e) {
                console.log(e)
            }
        }
        $scope.validateExamProceed = false;


            function modifyLoginDetails(){
                let obj_green = {
                    "border-radius": "5px" ,
                    "background-color":'green',
                    "padding": 5,
                    "color": "white"      
                }
                let obj_red = {
                    "border-radius": "5px" ,
                    "background-color":'red',
                    "padding": 5,
                    "color": "white"        
                }
                for (let n = 0; n < $scope.assignedUsers.length; n++) {
                let lock_validate = true
                var flag=0;
                if ($scope.assignedUsers[n].user_logged && $scope.assignedUsers[n].user_logged.length>0) {
                    
                
                    let userDetails=$scope.assignedUsers[n].user_logged;                    
                    for(let m=0;m<userDetails.length;m++){
                        let validate=false;                        
                        for(let j=0;j<userDetails.length;j++){ 
                            
                            
                            if (m != j) 
                            {
                                    if(userDetails[m]['uuid']==userDetails[j]['uuid']){
                                        validate=true                                      
                                    }
                            }
                        }
                        if(validate==true){                           
                            $scope.assignedUsers[n].user_logged[m]['color']=obj_green                            
                        }
                        else{
                            $scope.assignedUsers[n].user_logged[m]['color']= obj_red
                            flag=flag+1
                        }
                        if(userDetails.length==1){
                            flag=0;
                            $scope.assignedUsers[n].user_logged[m]['color']=obj_green       
                        }
                } 
                
                }
                            if(flag>0){
                    $scope.assignedUsers[n]['validate_user_login']={
                        "color":'red',
                        "float": "right",
                        "padding": 0,
                        "animation": "blinker 1s linear infinite"
                    }   
                }
                else{
                    $scope.assignedUsers[n]['validate_user_login']={
                        "color":'green',
                        "float": "right",
                        "padding": 0,
                    }    
                }              
            }
        }

        self.openMenu = function ($mdOpenMenu, ev) {
            console.log(ev)
            $mdOpenMenu(ev);
        };

        function generateAlertMessage() {
            $scope.poceedingStuList = []
            toastr.options.timeOut = 5000;
            toastr.options.positionClass = "toast-bottom-right";
            toastr.options.closeButton = true;
            for (let n = 0; n < $scope.assignedUsers.length; n++) {

                if ($scope.assignedUsers[n].examOutStatus && $scope.assignedUsers[n].status == 'attending') {
                    $scope.validateExamProceed = true;
                    $scope.poceedingStuList.push($scope.assignedUsers[n])
                    toastr.info($scope.assignedUsers[n].name + ' is waiting to start the exam.');
                }
            }
            if ($scope.poceedingStuList.length == 0) {
                $scope.validateExamProceed = false;
            }
            _.defer(function () {
                $scope.$apply();
            });
        }

        $scope.is_call_api = undefined
        function makeInterval(flag) {
            if (!flag) {
                $scope.is_call_api = setInterval(function () {
                    getQp();
                }, 10000);
            } else {
                clearInterval($scope.is_call_api)
            }

        }
        makeInterval(false)
        $scope.answerPreview = function (studentId) {
            $state.go('teacherAnswerView', {
                qpId: qpId,
                studentId: studentId
            })
        }
        $scope.answerPreview1 = function (studentId) {
            $scope.studentId = studentId
            if ($rootScope.online) {
                authService.callAPI(activityCons.API_GET_ANSWER_DETAILS + $scope.questionPaper._id + '/' + studentId, "GET", {}, function (response) {
                    if (response.result && response.result.data && response.result.data.details) {
                        try {
                            let result = response.result.data.details;
                            let useFullScreen = ($mdMedia('sm') || $mdMedia('xs'));
                            $scope.my_score = 0
                            $scope.totalmark = 0
                            $scope.quesCount = 0
                            let myScore = 0
                            $scope.isTeacherEvaluation = false
                            _.each(result.consolidatedData, function (sec) {
                                delete sec.questions
                                _.each(sec.answers, function (ans) {
                                    if (ans.type === "SA" || ans.type === "LA" || ans.type == "ASLLISTEN" || ans.type == "ASLSPEAK" || ans.type == "DRAW") {
                                        $scope.quesCount++;
                                    }
                                    $scope.totalmark = ans.total_mark
                                    if (!isNaN(ans.my_score)) {
                                        myScore = parseFloat(myScore) + parseFloat(ans.my_score)
                                        myScore = myScore.toFixed(2)
                                        $scope.my_score = myScore
                                    }
                                })
                            })
                            if ($scope.quesCount > 0 && $scope.questionPaper.status != 'published')
                                $scope.isTeacherEvaluation = true
                            $scope.questions = result.consolidatedData;
                            setTimeout(() => {
                                $scope.loadLatex()
                            }, 100);
                            setChoice();
                            $mdDialog.show({
                                templateUrl: teacherViewAnswerUrl,
                                clickOutsideToClose: true,
                                scope: $scope,
                                fullscreen: useFullScreen,
                                preserveScope: true
                            })
                                .then(function () { }, function () {
                                    self.status = 'You cancelled the dialog.';
                                })
                        } catch (ex) {
                            console.log(ex);
                        }
                    } else {
                        toastr.error('Network Error. Please try later');
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                });
            } else {
                let consolidatedData = []
                nodeAPIService.callAPI(API_GET_FETCH_MY_ANSWER + schoolId + "/" + studentId + "/" + activityId, "GET", undefined, function (response) {
                    if (response.result != undefined) {
                        let useFullScreen = ($mdMedia('sm') || $mdMedia('xs'));
                        let result = response.result.data.data
                        $scope.my_score = 0
                        $scope.totalmark = 0
                        $scope.quesCount = 0
                        let myScore = 0
                        if (result && result.answerDetails && result.answerDetails.length > 0) {
                            $scope.totalmark = result.answerDetails[0].total_mark
                            $scope.my_score = result.answerDetails[0].score
                            $scope.qpTitle = result.answerDetails[0].qp_title
                            $scope.class = result.answerDetails[0].class
                            $scope.batch = result.answerDetails[0].batch
                            $scope.subject = result.answerDetails[0].subject
                            $scope.date = result.answerDetails[0].date
                            if (result.answerDetails[0].time) {
                                if ($scope.hour = result.answerDetails[0].time.hour)
                                    $scope.hour = result.answerDetails[0].time.hour
                                if ($scope.min = result.answerDetails[0].time.min)
                                    $scope.min = result.answerDetails[0].time.min
                            }
                            $scope.questions = result.answerDetails
                        }
                        if (result && result.schoolDetails && result.schoolDetails.length > 0) {
                            $scope.schoolName = result.schoolDetails[0].school_name
                            $scope.schoolLogo = SchoolLogo.checkLogo(FILE_UPLOAD_URL + result.schoolDetails[0].logo)
                        }
                    } else {
                        toastr.error('Network Error. Please try later');
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                });
            }
        }

        $scope.checkingChoiceExists = function (choice, data) {
            let isChecked = false;
            if (data.my_answer != undefined) {
                return data.my_answer.indexOf(choice) > -1
            } else {
                return isChecked
            }
        }

        let MQ = MathQuill.getInterface(2);
        $scope.loadLatex = function () {
            let questionElements = document.getElementsByClassName('question_desc')
            _.each(questionElements, function (spanElement) {
                MQ.StaticMath(spanElement);
            })
        }

        $scope.markValidation = (questionId, sectionIndex, section, qnMark) => {
            let answersMarkCount = 0
            _.each(section.answers, function (data) {
                if (parseFloat(data.my_score) > 0) {
                    answersMarkCount++
                }
            })
            if (answersMarkCount > section.mandatory_no) {
                let questionIndex = section.answers.findIndex(i => i._id === questionId)
                section.answers[questionIndex].my_score = 0
                toastr.error(" You have already entered the marks all mandatory question")
                section.answers[sectionIndex]
            };
            let actualScore = 0;
            let totalScore = qnMark
            let questionIndex = $scope.questions[sectionIndex].answers.findIndex(i => i._id === questionId)
            if (questionIndex > -1) {
                actualScore = $scope.questions[sectionIndex].answers[questionIndex].my_score
            }
            if (actualScore > totalScore)
                $scope.questions[sectionIndex].answers[questionIndex].my_score = 0
        }

        function removeSpecialCharacter(value) {
            if (value) {
                value = value.toString().replace(/\\quad/g, "")
                value = value.toString().replace(/\\/g, "")
            }
            return value
        }

        /* Set answered choice is wrong or correct*/
        function setChoice() {
            _.each($scope.questions, function (section) {
                _.each(section.answers, function (data, key) {
                    $scope.total_mark += parseFloat(data.mark)
                    let score = parseFloat(data.my_score)
                    $scope.score += score;
                    if (data.type == 'MCQ' || data.type == "IBT_MCQ") {
                        _.each(data.choice, function (choice) {
                            if ($scope.checkingChoiceExists(choice.desc, data)) {
                                if (!choice.correct) {
                                    choice.wrong = true
                                }
                            }
                        })
                    } else if (data.type == 'TF') {
                        _.each(data.choice, function (choice) {
                            if (data.my_answer != undefined && choice.tag === data.my_answer[0]) {
                                if (!choice.correct) {
                                    choice.wrong = true
                                } else {
                                    choice.correct = true
                                }
                            }
                        })
                    } else if (data.type == 'FIB' || data.type == "IBT_FIB") {
                        let key = 0
                        _.each(data.answer, function (choice) {
                            let correctAnswer = removeSpecialCharacter(choice.desc)
                            if (data.my_answer != undefined && data.my_answer[key] != undefined) {
                                let studentAnswer = removeSpecialCharacter(data.my_answer[key])
                                if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                    choice.wrong = true
                                } else {
                                    choice.correct = true
                                }
                            } else {
                                choice.wrong = true
                                if (data.my_answer != undefined) {
                                    data.my_answer[key] = 'Not Answered'
                                } else {
                                    data.my_answer = []
                                    data.my_answer[key] = 'Not Answered'
                                }
                            }
                            key++
                        })
                    } else if (data.type == 'OWQ') {
                        let key = 0
                        _.each(data.answer, function (choice) {
                            let correctAnswer = removeSpecialCharacter(choice.desc)
                            if (data.my_answer != undefined && data.my_answer[key] != undefined) {
                                let studentAnswer = removeSpecialCharacter(data.my_answer[key])
                                if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                    choice.wrong = true
                                } else {
                                    choice.correct = true
                                }
                            } else {
                                choice.wrong = true
                                if (data.my_answer != undefined) {
                                    data.my_answer[key] = 'Not Answered'
                                } else {
                                    data.my_answer = []
                                    data.my_answer[key] = 'Not Answered'
                                }
                            }
                            key++
                        })
                    } else if (data.type == 'MTF') {
                        data.ans_key = []
                        let key = 0
                        _.each(data.option, function (choice) {
                            let correctAnswer = removeSpecialCharacter(choice.answer.desc)
                            if (data.my_answer != undefined && data.my_answer[key] != undefined) {
                                let correct = false
                                let studentAnswer = removeSpecialCharacter(data.my_answer[key].desc)
                                if (correctAnswer !== studentAnswer) {
                                    correct = false
                                } else {
                                    correct = true
                                }
                                data.ans_key.push({
                                    desc: data.my_answer[key].desc,
                                    correct: correct,
                                    optImage: data.my_answer[key].optImage
                                })
                            }
                            key++
                        })
                    } else if (data.type == 'ASLLISTEN') {
                        _.each(data.questions, function (aslListQues) {
                            if (aslListQues.type == 'mcq') {
                                _.each(aslListQues.choice, function (choice) {
                                    if ($scope.checkingChoiceExists(choice.desc, aslListQues)) {
                                        if (!choice.correct) {
                                            choice.wrong = true
                                        }
                                    }
                                })
                            } else if (aslListQues.type == 'tf') {
                                _.each(aslListQues.choice, function (choice) {
                                    if (aslListQues.my_answer != undefined && choice.tag === aslListQues.my_answer) {
                                        if (!choice.correct) {
                                            choice.wrong = true
                                        } else {
                                            choice.correct = true
                                        }
                                    }
                                })
                            } else if (aslListQues.type == 'fib') {
                                _.each(aslListQues.answer, function (choice, index) {
                                    let correctAnswer = removeSpecialCharacter(choice.desc)
                                    if (aslListQues.my_answer != undefined && aslListQues.my_answer[index] != undefined) {
                                        let studentAnswer = removeSpecialCharacter(aslListQues.my_answer[index])
                                        if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                            choice.wrong = true
                                        } else {
                                            choice.correct = true
                                        }
                                    } else {
                                        choice.wrong = true
                                        if (aslListQues.my_answer != undefined) {
                                            aslListQues.my_answer[index] = 'Not Answered'
                                        } else {
                                            aslListQues.my_answer = []
                                            aslListQues.my_answer[index] = 'Not Answered'
                                        }
                                    }
                                })
                            } else if (aslListQues.type == 'text') {
                                let correctAnswer = removeSpecialCharacter(aslListQues.answer)
                                if (aslListQues.my_answer != undefined) {
                                    let studentAnswer = removeSpecialCharacter(aslListQues.my_answer)
                                    if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                        aslListQues.wrong = true
                                    } else {
                                        aslListQues.correct = true
                                    }
                                } else {
                                    aslListQues.wrong = true
                                    aslListQues.my_answer = 'Not Answered'
                                }
                            }
                        })
                    }
                })
            })
        }

        $scope.score = $scope.score.toFixed(2)
        $scope.cancel = function () {
            $mdDialog.hide();
        };

        $scope.gotoActivityPreview = function () {
            $state.go('qpSummary', {
                qpId: qpId
            })
        }

        $scope.saveMark = function () {
            let errorCount = 0;
            _.each($scope.questions, function (section) {
                _.each(section.answers, function (quest) {
                    //mark_each_qn changed to qn_mark
                    //For individual mark  for each question
                    //Developer-Raziya
                    quest.qn_mark = parseFloat(quest.qn_mark)
                    if (quest.my_score > quest.qn_mark) {
                        quest.mark_error = "Enter the mark less than total mark"
                        errorCount++;
                    }
                })
            })
            if (errorCount > 0) {
                toastr.error("Check the marks")
            } else {
                let requestObj = {
                    questions: $scope.questions,
                    student_id: $scope.studentId,
                    question_paper_id: $scope.questionPaper._id,
                    user_id: userId,
                    authoring_data: authoring
                }
                authService.callAPI(activityCons.API_UPDATE_EXAM_SCORE, "POST", requestObj, function (response) {
                    if (response.result && response.result.data && response.result.data.message) {
                        try {
                            let result = response.result.data.message;
                            toastr.success(result);
                            $mdDialog.hide();
                        } catch (ex) {
                            console.log(ex);
                        }
                    } else {
                        toastr.error('Network Error. Please try later');
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                });
            }
        }

        $scope.setFilePath = function (img) {
            let new_url = img ? FILE_UPLOAD_URL + img : undefined
            return new_url
        }

        $scope.beautifyFIB = function (question) {
            return question.toString().replace(/_/g, " _______ ")
        }

        function getTime(millseconds) {
            var oneSecond = 1000;
            var oneMinute = oneSecond * 60;
            var oneHour = oneMinute * 60;
            var oneDay = oneHour * 24;
            var seconds = Math.floor((millseconds % oneMinute) / oneSecond);
            var minutes = Math.floor((millseconds % oneHour) / oneMinute);
            var hours = Math.floor((millseconds % oneDay) / oneHour);
            var days = Math.floor(millseconds / oneDay);
            var timeString = '';
            if (days !== 0) {
                timeString += (days !== 1) ? (days + ' days ') : (days + ' day ');
            }
            if (hours !== 0) {
                timeString += (hours !== 1) ? (hours + ' hours ') : (hours + ' hour ');
            }
            if (minutes !== 0) {
                timeString += (minutes !== 1) ? (minutes + ' min ') : (minutes + ' min ');
            }
            if (seconds !== 0 || millseconds < 1000) {
                timeString += (seconds !== 1) ? (seconds + ' sec ') : (seconds + ' sec ');
            }
            return timeString;
        }

        $scope.isString = function (value) {
            return typeof value == 'string'
        }
        $scope.$on("$destroy", function () {
            makeInterval(true)
        });
        $scope.showProgresspopup = function (array) {
            if (array) {
                $mdDialog.show({
                    controller: ['$scope', '$mdMedia', '$mdDialog', 'array',
                        'parentScope', ProgressPreviewController],
                    template: templateProgressPopup,
                    parent: angular.element(document.body),
                    locals: {
                        array: array,
                        parentScope: $scope,
                    },
                    clickOutsideToClose: true,
                })
            } else {
                toastr.error("No progress Data")
            }
        }


        $scope.changeStudentTabColor = (studList) => {
            let assignedUsers = $scope.assignedUsers
            let ex = _.find(assignedUsers, function (one) {
                return one._id == studList._id
            })
            if (ex) {
                ex.tab_color = false
                console.log(ex)
            }
            // for (let m = 0; m < assignedUsers.length; m++) {

            // }
        }
        $scope.showColor = function (obj) {
            let string = "<span style='color: #00000'>" + obj.name + "</span>"
            if (obj && obj.tab_color) {
                string = "<span style='background:red;padding:5px;color: white !important;'>" + obj.name + "</span>"
            }
            return $sce.trustAsHtml(string);
        }
        $scope.ExamProceedAllow = () => {
            console.log($scope.poceedingStuList)
            $mdDialog.show({
                controller: ['$scope', '$mdMedia', '$mdDialog',
                    'parentScope', 'authService', 'CONSTANTS', 'poceedingStuList', 'qpId', ExamProceedViewController],
                template: proceedViewPopup,
                parent: angular.element(document.body),
                locals: {
                    parentScope: $scope,
                    authService: authService,
                    CONSTANTS: CONSTANTS,
                    poceedingStuList: $scope.poceedingStuList,
                    qpId: qpId
                },
                clickOutsideToClose: true,
            })
        }



        $scope.viewOneStudent = (one_student) => {

            $scope.editDialog = $mdDialog;
            $scope.editDialog.show({




                // $mdDialog.show({
                controller: ['$scope', '$mdMedia', '$mdDialog',
                    'parentScope', 'authService', 'CONSTANTS', 'studList', 'qpId', ProcturingViewController],
                template: procturedDocumentPopup,
                parent: angular.element(document.body),
                locals: {
                    parentScope: $scope,
                    authService: authService,
                    CONSTANTS: CONSTANTS,
                    studList: one_student,
                    qpId: qpId
                },
                clickOutsideToClose: false,
                multiple: true
            })
        }
        let scope = $scope
        $scope.autoEvaluate = (event) => {
            var confirm = $mdDialog.confirm({
                targetEvent: event,
                onComplete: function afterShowAnimation() {
                    var $dialog = angular.element(document.querySelector('md-dialog'));
                    var $actionsSection = $dialog.find('md-dialog-actions');
                    var $cancelButton = $actionsSection.children()[0];
                    var $confirmButton = $actionsSection.children()[1];
                    angular.element($confirmButton).addClass('md-raised md-accent');
                    angular.element($cancelButton).addClass('md-raised');
                    var $title = angular.element(document.querySelector('md-title'));
                    angular.element($title).addClass('md-raised md-accent');

                }
            })
                .title('Are you sure to proceed')
                .textContent('This action will evaluate the question types - MCQ, OWQ, TF and MTF')
                .ok('Proceed')
                .cancel('Cancel');

            $mdDialog.show(confirm).then(function () {
                scope.questionPaper.auto_evaluating = true
                let requestObj = {
                    school_id: schoolId,
                    qp_id: qpId
                }
                authService.callAPI("/v0/auto/evaluate/students/activity", "POST", requestObj, function (response) {
                    if (response.result && response.result.data && response.result.data.message) {
                        try {
                            toastr.success("Auto evaluation is on progress.Please check after some minute(s)")
                        } catch (ex) {
                            console.log(ex);
                        }
                    } else {
                        toastr.error('Network Error. Please try later');
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                });
            }, function () {
                toastr.info("You cancelled the process")
            });
            // 
        }
    }
}
export default ActivitySubmissionController
class ProgressPreviewController {
    constructor($scope, $mdMedia, $mdDialog, array,
        parentScope) {
        'ngInject';
        $scope.array = array;

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

    }
}
class ProcturingViewController {
    constructor($scope, $mdMedia, $mdDialog,
        parentScope, authService, CONSTANTS, studList, qpId) {
        'ngInject';

        $scope.cancel = function () {
            $mdDialog.cancel();
        };


        let obj = {
            qp_id: qpId,
            student_id: studList._id,
            status: "attending",
            FILE_UPLOAD_URL: CONSTANTS.CLOUD_URL
        }
        $scope.studList = studList
        function attachFILESERVER(array) {
            let FILE_UPLOAD_URL = CONSTANTS.CLOUD_URL
            let arr = []
            for (let a = 0; a < array.length; a++) {
                let path = FILE_UPLOAD_URL + array[a]['path']
                array[a]['path'] = path
                arr.push(array[a])
            }
            arr.sort(function (a, b) {
                // Turn your strings into dates, and then subtract them
                // to get a value that is either negative, positive, or zero.
                return new Date(b.datetime) - new Date(a.datetime);
            })
            return arr
        }
        function imageZoom(imgID, resultID) {
            var img, lens, result, cx, cy;
            img = document.getElementById(imgID);
            if(img){
                result = document.getElementById(resultID);
                /* Create lens: */
                lens = document.createElement("DIV");
                lens.setAttribute("class", "img-zoom-lens");
                /* Insert lens: */
                img.parentElement.insertBefore(lens, img);
                /* Calculate the ratio between result DIV and lens: */
                cx = result.offsetWidth / lens.offsetWidth;
                cy = result.offsetHeight / lens.offsetHeight;
                /* Set background properties for the result DIV */
                result.style.backgroundImage = "url('" + $scope.one_image.path + "')";
                result.style.backgroundSize = (img.width * cx) + "px " + (img.height * cy) + "px";
                /* Execute a function when someone moves the cursor over the image, or the lens: */
                lens.addEventListener("mousemove", moveLens);
                img.addEventListener("mousemove", moveLens);
                /* And also for touch screens: */
                lens.addEventListener("touchmove", moveLens);
                img.addEventListener("touchmove", moveLens);
                function moveLens(e) {
                    var pos, x, y;
                    /* Prevent any other actions that may occur when moving over the image */
                    e.preventDefault();
                    /* Get the cursor's x and y positions: */
                    pos = getCursorPos(e);
                    /* Calculate the position of the lens: */
                    x = pos.x - (lens.offsetWidth / 2);
                    y = pos.y - (lens.offsetHeight / 2);
                    /* Prevent the lens from being positioned outside the image: */
                    if (x > img.width - lens.offsetWidth) { x = img.width - lens.offsetWidth; }
                    if (x < 0) { x = 0; }
                    if (y > img.height - lens.offsetHeight) { y = img.height - lens.offsetHeight; }
                    if (y < 0) { y = 0; }
                    /* Set the position of the lens: */
                    lens.style.left = x + "px";
                    lens.style.top = y + "px";
                    /* Display what the lens "sees": */
                    result.style.backgroundPosition = "-" + (x * cx) + "px -" + (y * cy) + "px";
                }
            }
            
            function getCursorPos(e) {
                var a, x = 0, y = 0;
                e = e || window.event;
                /* Get the x and y positions of the image: */
                a = img.getBoundingClientRect();
                /* Calculate the cursor's x and y coordinates, relative to the image: */
                x = e.pageX - a.left;
                y = e.pageY - a.top;
                /* Consider any page scrolling: */
                x = x - window.pageXOffset;
                y = y - window.pageYOffset;
                return { x: x, y: y };
            }
        }
        $scope.one_image = {}
        $scope.one_audio = {}


        makeIntervalProctoring(false)

        $scope.is_call_api_proctoring = undefined
        function makeIntervalProctoring(flag) {
            if (!flag) {
                $scope.is_call_api_proctoring = setInterval(function () {
                    getProctoringImages();
                }, 50000);
            } else {
                clearInterval($scope.is_call_api_proctoring)
            }

        }

        getProctoringImages()
        function getProctoringImages() {
            try {
                $scope.one_image = {}
                authService.callAPI("/v0/activity/attendees/images", "POST", obj, function (response) {
                    if (response.result) {
                        let data = response.result.data
                        let proctured_data = {}
                        proctured_data['cameraShots'] = attachFILESERVER(data.cameraShots)
                        $scope.one_image.path = proctured_data['cameraShots'][0]['path']
                        imageZoom("myimage", "myresult");
                        proctured_data['activityShots'] = attachFILESERVER(data.activityShots)
                        proctured_data['textShots'] = data.textShots
                        proctured_data['examStudentStatus'] = data.examStudentStatus
                        if (data.examQPDetails) {
                            if (data.examQPDetails.examOutStatus) {
                                proctured_data['examOutStatus'] = data.examQPDetails.examOutStatus
                            }
                        }
                        $scope.proctured_data = proctured_data
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                });
            } catch (e) {
                console.log(e)
            }
        }

        let file = "/home/cordova/count.txt"
        $scope.imageDetails = (one_image) => {
            $scope.one_image = one_image
            imageZoom("myimage", "myresult");
            _.defer(function () {
                $scope.$apply();
            });
        }
        $scope.audioDetails = (one_audio) => {
            $scope.one_audio.audio = one_audio
            _.defer(function () {
                $scope.$apply();
            });
        }
        const downloadFile = (url, outputstr) => {
            fetch(url).then(resp => resp.arrayBuffer()).then(resp => {
                try {
                    // set the blog type to final pdf
                    const file = new Blob([resp], { type: 'application/mp3' });
                    // process to auto download it
                    const fileURL = URL.createObjectURL(file);
                    const link = document.createElement('a');
                    link.href = fileURL;
                    link.click();
                } catch (e) {
                    console.log(e)
                }
            });
        };
       
        $scope.download = (data) => {
            let url = data.path
            downloadFile(url)
        }

        $scope.showConfirm = function (ev, funName) {
            var titleMsg;
            $scope.funName = funName
            if (funName == 'stopExam') {
                titleMsg = 'Would you like to stop the exam ?'
            }
            if (funName == 'proceedExam') {
                titleMsg = 'Would you like to unlock the exam ?'
            }
            if (funName == 'sendWarning') {
                titleMsg = 'Would you like to send a warning message ?'
            }
            if (funName == 'takePhoto') {
                titleMsg = 'Would you like to take the current snap shot?'
            }

            var confirm = $mdDialog.confirm()
                .title(titleMsg)
                .targetEvent(ev)
                .ok('Yes')
                .cancel('No')
                .multiple(true);

            $mdDialog.show(confirm).then(function () {
                console.log($scope.funName)
                if ($scope.funName == 'stopExam') {
                    $scope.stopExam();
                }
                if ($scope.funName == 'proceedExam') {

                    $scope.proceedExam();
                }
                if ($scope.funName == 'sendWarning') {
                    $scope.sendWarning();
                }
                if ($scope.funName == 'takePhoto') {
                    $scope.takePhoto();
                }

            }, function () {

            });
        };

        $scope.proceedExam = function () {           
           updateStudentExamQPDetails();
           $scope.proctured_data.examOutStatus = false;
        }
        $scope.stopExam = function () {
            updateStudentExam('forcedToSubmit');
        }
        $scope.sendWarning = function () {
            updateStudentExam('sendWarning');
        }
        $scope.takePhoto = function () {
            updateStudentExam('takePhoto');
        }
        function updateStudentExamQPDetails() {
            try {
                let obj = {
                    qp_id: qpId,
                    student_id: studList._id
                }
                authService.callAPI("/v0/activity/attendees/update/exam/qp/details", "POST", obj, function (response) {
                    if (response.result) {

                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                });
            } catch (e) {
                console.log(e)
            }
        }
        function updateStudentExam(changeStatus) {
            try {
                let obj = {
                    qp_id: qpId,
                    student_id: studList._id,
                    changeStatus: changeStatus,
                }
                authService.callAPI("/v0/activity/attendees/update/exam", "POST", obj, function (response) {
                    if (response.result) {

                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                });
            } catch (e) {
                console.log(e)
            }
        }
    }
}




class ExamProceedViewController {
    constructor($scope, $mdMedia, $mdDialog,
        parentScope, authService, CONSTANTS, poceedingStuList, qpId) {
        'ngInject';

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.qpId = qpId;

        let arr = []
        for (let m = 0; m < poceedingStuList.length; m++) {
            let keys = Object.keys(poceedingStuList[m])
            let obj = {}
            for (let k = 0; k < keys.length; k++) {
                obj[keys[k]] = poceedingStuList[m][keys[k]]
            }
            arr.push(obj)

        }
        $scope.poceedingStuListNEW = arr;
        $scope.isChecked = false;

        $scope.proceedExamALLBtn =false ;
        $scope.proceedExam = function (studList) {
            updateStudentExamQPDetails(studList._id, studList);
            _.defer(function () {
                $scope.$apply();
            });
        }

        $scope.proceedExamALL = function () {
            for (let k = 0; k < $scope.poceedingStuListNEW.length; k++) {
                if ($scope.poceedingStuListNEW[k]['isChecked']) {
                   updateStudentExamQPDetails($scope.poceedingStuListNEW[k]._id, $scope.poceedingStuListNEW[k]);
                }
            }           
            _.defer(function () {
                $scope.$apply();
            });
        }

        $scope.selectAll = function () {
            for (let k = 0; k < $scope.poceedingStuListNEW.length; k++) {
                if ($scope.isChecked) {
                    $scope.poceedingStuListNEW[k]['isChecked'] = true
                }
                else {
                    $scope.poceedingStuListNEW[k]['isChecked'] = false
                }
            }
            if($scope.isChecked){
                $scope.proceedExamALLBtn =true ;
            }else{
                $scope.proceedExamALLBtn =false ;
            }
        }

        $scope.showConfirmProceed = function (ev) {
            var titleMsg ='Would you like to unlock the exam of all the students ?';                       
            var confirm = $mdDialog.confirm()
                .title(titleMsg)
                .targetEvent(ev)
                .ok('Yes')
                .cancel('No')
                .multiple(true);
            $mdDialog.show(confirm).then(function () {
                $scope.proceedExamALL();
            }, function () {

            });
        };

        function updateStudentExamQPDetails(student_id, studList) {
            try {
                let obj = {
                    qp_id: $scope.qpId,
                    student_id: student_id
                }
                authService.callAPI("/v0/activity/attendees/update/exam/qp/details", "POST", obj, function (response) {
                    if (response.result) {
                        for (let m = 0; m < $scope.poceedingStuListNEW.length; m++) {
                            if ($scope.poceedingStuListNEW[m]._id == student_id) {
                                $scope.poceedingStuListNEW.splice(m, 1);
                            }
                        }

                        if ($scope.poceedingStuListNEW.length <= 0) {
                            parentScope.validateExamProceed = false;
                            $mdDialog.cancel();
                        }

                        parentScope.changeStudentTabColor(studList)

                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                });
            } catch (e) {
                console.log(e)
            }
        }


    }
}


// WEBPACK FOOTER //
// ./src/app/traditionalActivity/controllers/viewSubmissionList.js